import firebase from 'firebase'
import Rebase from "re-base";

var config = {
    apiKey: "AIzaSyAZzKq2AtHaty0GnT75uv3xbTnDlV6_s-I",
    authDomain: "testvs-f96db.firebaseapp.com",
    databaseURL: "https://testvs-f96db.firebaseio.com",
    projectId: "testvs-f96db",
    storageBucket: "testvs-f96db.appspot.com",
    messagingSenderId: "746441394642",
    appId: "1:746441394642:web:8aff837ad776b548dda00b"
};


const fire = firebase.initializeApp(config);
const base = Rebase.createClass(fire.database());
const storage = fire.storage();

export { fire, base, storage };
